import { MAIN_URL } from '../constants';

// Backend fayl maydonlari (photo, identity_card, edu_doc) nisbiy yo'l bilan keladi ("media/student/photo/...") —
// base URL qo'shiladi. To'liq URL o'zgarmaydi. Bo'sh qiymat (null, "") → null: rasm yoki havola ko'rsatilmaydi.
export function mediaUrl(path) {
  if (typeof path !== 'string') return null;
  const value = path.trim();
  if (!value) return null;
  if (/^(https?:|blob:|data:)/i.test(value)) return value;
  return `${MAIN_URL}/${value.replace(/^\/+/, '')}`;
}
